<template>
	<div>
		<b-row class="justify-content-lg-center">
			<b-col>
                <b-row class="mb-2">
                    <b-col>
                        <b-form-row>
                            <b-col :md="6" lg="3">
                                <b-form-group
                                    id="form_label_start_date"
                                    :label="$t('report_label_start_date')"
                                    label-for="filterStartDate"
                                    label-size="sm"
                                    label-class="mb-0"
                                >
                                    <b-form-datepicker id="filterStartDate" v-model="filterStartDate" :max="filterEndDate" />
                                </b-form-group>
                            </b-col>
                            <b-col :md="6" :lg="3">
                                <b-form-group
                                    id="form_label_end_date"
                                    :label="$t('report_label_end_date')"
                                    label-for="filterEndDate"
                                    label-size="sm"
                                    label-class="mb-0"
                                >
                                    <b-form-datepicker id="filterEndDate" v-model="filterEndDate" :min="filterStartDate" />
                                </b-form-group>
                            </b-col>
                            <b-col :md="5" :lg="2">
                                <b-form-group 
                                    :label="$t('report_label_worker')" 
                                    label-for="filterWorker" 
                                    label-size="sm" 
                                    label-class="mb-0"
                                >
                                    <v-select
                                        :options="workerFilterOptions(filterWorkers(workers))"
                                        :reduce="worker => worker.val"
                                        label="label"
                                        v-model="filterWorker"
                                        :clearable="false"
                                    >
                                        <template #search="{attributes, events}">
                                            <input
                                                class="vs__search"
                                                :required="!filterWorker"
                                                v-bind="attributes"
                                                v-on="events"
                                            />
                                        </template>
                                        <div slot="no-options">{{ $t('app_vselect_no_options_found') }}</div>
                                    </v-select>
                                </b-form-group>
                            </b-col>
                            <b-col :md="5" :lg="2">
                                <b-form-group 
                                    :label="$t('report_label_product')" 
                                    label-for="filterProduct" 
                                    label-size="sm" 
                                    label-class="mb-0"
                                >
                                    <v-select
                                        :options="productFilterOptions(products)"
                                        :reduce="product => product.val"
                                        label="label"
                                        v-model="filterProduct"
                                        :clearable="false"
                                    >
                                        <template #search="{attributes, events}">
                                            <input
                                                class="vs__search"
                                                :required="!filterProduct"
                                                v-bind="attributes"
                                                v-on="events"
                                            />
                                        </template>
                                        <div slot="no-options">{{ $t('app_vselect_no_options_found') }}</div>
                                    </v-select>
                                </b-form-group>
                            </b-col>
                            <b-col :md="2" :lg="2" class="d-flex">
                                <b-form-group class="mt-auto">
                                    <b-button @click="searchByDate" variant="info">{{ $t('report_modal_button_search') }}</b-button>
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col>
                        <b-list-group>
                            <b-list-group-item>
                                <b-row>
                                    <b-col>
                                        <b>{{ $t('report_title_tasks') }}:</b>
                                    </b-col>
                                    <b-col sm="8">
                                        {{ $moment(filterStartDate).format(dateFormat) }} - {{ $moment(filterEndDate).format(dateFormat) }}
                                    </b-col>
                                </b-row>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-row>
                                    <b-col>
                                        <b>{{ $t('report_label_tasks_count') }}:</b>
                                    </b-col>
                                    <b-col sm="8">
                                        {{ tasksCount }}
                                    </b-col>
                                </b-row>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-row>
                                    <b-col>
                                        <b>{{ $t('report_label_duration_total') }}:</b>
                                    </b-col>
                                    <b-col sm="8">
                                        {{ tasksDurationTotal }}
                                    </b-col>
                                </b-row>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-row>
                                    <b-col>
                                        <b>{{ $t('report_label_duration_average') }}:</b>
                                    </b-col>
                                    <b-col sm="8">
                                        {{ tasksDurationAverage }}
                                    </b-col>
                                </b-row>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-row>
                                    <b-col>
                                        <b>{{ $t('report_label_daily_average') }}:</b>
                                    </b-col>
                                    <b-col sm="8">
                                        {{ tasksDailyAverage }}
                                    </b-col>
                                </b-row>
                            </b-list-group-item>
                            <!--
                            <b-list-group-item>
                                <b-row>
                                    <b-col>
                                        <b>{{ $t('report_label_weekly_average') }}:</b>
                                    </b-col>
                                    <b-col sm="8">
                                        {{ tasksWeeklyAverage }}
                                    </b-col>
                                </b-row>
                            </b-list-group-item>
                            -->
                        </b-list-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-list-group>
                            <b-list-group-item>
                                <b-row>
                                    <b-col>
                                        <b>{{ $t('report_label_task_start_times') }}:</b>
                                    </b-col>
                                    <b-col md="8">
                                        <apexchart 
                                            width="100%" 
                                            :options="taskTimeChart.options" 
                                            :series="taskTimeChart.series"
                                        />
                                    </b-col>
                                </b-row>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-row>
                                    <b-col>
                                        <b>{{ $t('report_label_task_weekdays') }}:</b>
                                    </b-col>
                                    <b-col md="8">
                                        <apexchart 
                                            width="100%" 
                                            :options="taskWeekdayChart.options" 
                                            :series="taskWeekdayChart.series"
                                        />
                                    </b-col>
                                </b-row>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>
			</b-col>
		</b-row>
	</div>
</template>

<script>
export default {
    name: 'ReportIndex',
    props: [
        'tasks',
        'workers',
        'products',
		'filterWorkers',
		'getTasksByDate',
    ],
    data() {
        return {
            dateFormat: 'DD.MM.YYYY',
            filterStartDate: this.$moment(Date.now()).subtract(30, 'd').format(this.dateFormat),
            filterEndDate: this.$moment(Date.now()).format(this.dateFormat),
            filterWorker: "all",
            filterProduct: "all",
            tasksCount: 0,
            tasksDurationTotal: null,
            tasksDurationAverage: null,
            tasksDailyAverage: null,
            tasksWeeklyAverage: null,
            taskTimeChart: {
                options: {
                    chart: {
                        type: 'bar',
                        zoom: {
                            enabled: false
                        },
                    },
                    xaxis: {
                        categories: this.hourCategories(24),
                        title: {
                            text: this.$t('report_graph_task_amount_hours')
                        }
                    },
                    yaxis: [{
                        labels: {
                            formatter: function(val) {
                                return val.toFixed(0);
                            }
                        }
                    }]
                },
                series: [],
            },
            taskWeekdayChart: {
                defaultLocale: 'fi',
                options: {
                    chart: {
                        type: 'bar',
                        zoom: {
                            enabled: false
                        },
                    },
                    xaxis: {
                        categories: [
                            this.$t('app_weekday_monday_short'), 
                            this.$t('app_weekday_tuesday_short'), 
                            this.$t('app_weekday_wednesday_short'), 
                            this.$t('app_weekday_thursday_short'), 
                            this.$t('app_weekday_friday_short'), 
                            this.$t('app_weekday_saturday_short'), 
                            this.$t('app_weekday_sunday_short')
                        ],
                    },
                    yaxis: [{
                        labels: {
                            formatter: function(val) {
                                return val.toFixed(0);
                            }
                        }
                    }]
                },
                series: [],
            },
        }
    },
    methods: {
		searchByDate() {
            let start = this.$moment(this.filterStartDate).format('x');
            let end = this.$moment(this.filterEndDate).add(1, 'days').format('x');
            this.getTasksByDate(start, end);
        },
		filterTasks(tasks) {
            if (tasks.length) {
                return tasks.filter(task => {
                    if (task.worker.id === this.filterWorker || this.filterWorker == "all") {
                        if (this.filterProduct == "all") {
                            return task;
                        } else {
                            let taskProductIds = [];
                            task.products.filter(product => {
                                taskProductIds.push(product.product)
                            });
                            if (taskProductIds.includes(this.filterProduct)) {
                                return task;
                            }
                        }
                    }
                });
            } else {
                return [];
            }
        },
        workerFilterOptions(workers) {
			if (workers && workers.length) {
				let fWorkers = [{
                    val: "all",
                    label: this.$t('task_label_filter_all'),
                }];
				workers.forEach(worker => {
                    fWorkers.push({
                        val: worker.id,
                        label: `${worker.firstname} ${worker.lastname}`,
                    });
				});
				return fWorkers;
			}
        },
        productFilterOptions(products) {
			if (products && products.length) {
				let fProducts = [{
                    val: "all",
                    label: this.$t('task_label_filter_all'),
                }];
				products.forEach(product => {
                    fProducts.push({
                        val: product.id,
                        label: product.code && product.name ? `${product.code} - ${product.name}` : `${product.name}`,
                    });
				});
				return fProducts;
			}
        },
        hourCategories(amount) {
            let categories = [];
            for (var i=0; i<amount; i++) {
                categories.push(i);
            }
            return categories;
        },
        taskTimeChartData(tasks) {
            let amount = 24;
            let categories = this.hourCategories(amount);
            let hoursGraph = [];
            for (var i=0; i<amount; i++) {
                hoursGraph.push(0);
            }
            tasks.forEach(task => {
                var hour = this.$moment(task.startTime).format("H");
                hoursGraph[categories.indexOf(parseInt(hour))]++;
            });
            this.taskTimeChart.series = [{
                name: this.$t('report_graph_series_task_amount'),
                data: hoursGraph
            }];
        },
        taskWeekdayChartData(tasks) {
            let amount = 7;
            let hoursGraph = [];
            for (var i=0; i<amount; i++) {
                hoursGraph.push(0);
            }
            tasks.forEach(task => {
                var dayNumber = this.$moment(task.startTime).day();
                hoursGraph[dayNumber]++;
            });
            let sundayVal = hoursGraph[0];
            hoursGraph.splice(0, 1);
            hoursGraph.push(sundayVal);

            this.taskWeekdayChart.series = [{
                name: this.$t('report_graph_series_task_amount'),
                data: hoursGraph
            }];
        },
        calculateTaskData(tasks) {
            let tasksCount = tasks && tasks.length ? tasks.length : 0;
            this.tasksCount = tasksCount;

            var filterDuration = this.$moment(this.filterEndDate).format('x') - this.$moment(this.filterStartDate).format('x');
            var daysInDuration = Math.floor(filterDuration/1000/60/60/24);
            filterDuration -= daysInDuration*1000*60*60*24;
            this.tasksDailyAverage = tasks && tasks.length ? (tasks.length / daysInDuration).toFixed(2) : 0;

            let taskDurations = [];
            tasks.forEach(task => {
                let taskDuration = task.endTime - task.startTime;
                taskDurations.push(taskDuration);
            });
            // durations sum
            let totalDuration = 0;
            if (taskDurations.length) {
                totalDuration = taskDurations.reduce((total, duration) => {
                    return total + duration;
                });
            }
            // task duration total
            this.tasksDurationTotal = totalDuration ? this.durationToString(totalDuration) : 0;
            // task duration average
            this.tasksDurationAverage = totalDuration ? this.durationToString(totalDuration / tasksCount) : 0;

            // charts
            this.taskTimeChartData(tasks);
            this.taskWeekdayChartData(tasks);
        },
        durationToString(duration) {
            var daysDifference = Math.floor(duration/1000/60/60/24);
            duration -= daysDifference*1000*60*60*24;
            var hoursDifference = Math.floor(duration/1000/60/60);
            duration -= hoursDifference*1000*60*60;
            var minutesDifference = Math.floor(duration/1000/60);
            duration -= minutesDifference*1000*60;
            var secondsDifference = Math.floor(duration/1000);

            var durations = [];
            if (daysDifference) {
                durations.push(`${daysDifference} ${this.$t('task_duration_days')}`)
            }
            if (hoursDifference) {
                durations.push(`${hoursDifference} ${this.$t('task_duration_hours')}`)
            }
            if (minutesDifference) {
                durations.push(`${minutesDifference} ${this.$t('task_duration_minutes')}`)
            }
            if (secondsDifference) {
                durations.push(`${secondsDifference} ${this.$t('task_duration_seconds')}`)
            }
            return durations.join(', ');
        },
    },
    mounted () {
        this.searchByDate();
    },
    watch: {
        tasks() {
            let filteredTasks = this.filterTasks(this.tasks);
            this.calculateTaskData(filteredTasks);
            //this.daysDiff(, filteredTasks);
        }
    },
}
</script>
